<template src="./index.html"></template>
<script>
import data from './data.js';
import {
  dgsh_getCommentsByIds,
} from "../../../../api/dgsh.js";
export default {
	props: {
		ReviewAndApprovalNote: {
			type: Boolean,
			default: false
		},
		dataSources: {
			type: Array,
			default: function() {
				return [];
			}
		},
		edit:{
			type:Boolean,
			default:false
		},
		list:{
			type: Array,
			default: function() {
				return [{}];
			}
		},
		differentiate: {
			type: String,
			default: ''
		},
		textarea:{
			type: String,
			default: ''
		},
		title:{
			type: String,
			default: '审核批注'
		},
		name:{
			type: String,
			default: ''
		}
	},
	data() {
		return {
		};
	},
	created() {},
	mounted() {},
	watch: {
		ReviewAndApprovalNote: function(indexVal, oldVal) {
			if (indexVal) {
				// this.textarea=""
			}
		}
	},
	methods: {
		/* 关闭 */
		Answer_ReviewAndApprovalNote() {
			this.$emit('Answer_ReviewAndApprovalNote', '');
		},
		shengq() {
			this.$emit('shengq', this.dataSources,this.differentiate,this.textarea);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
